import { gql } from "@apollo/client";
import { LeaderboardFragment } from "graphql/leaderboard";

export const GET_PENDING_LEADERBOARDS = gql`
    query GetPendingLeaderboards($eventDivisionId: ID!, $round: Int!) {
        eventDivision(id: $eventDivisionId) {
            id
            formatDefinition {
                progression
                manualProgression
            }
            leaderboards(round: $round) {
                ...Leaderboard
                config {
                    jerseyOrder
                }
            }
            leaderboardsWithPending(round: $round) {
                ...Leaderboard
                config {
                    jerseyOrder
                }
            }
        }
    }
    ${LeaderboardFragment}
`;
